import * as React from 'react'
import {useContext, useRef, useState} from 'react'
import {useTranslation} from 'react-i18next'
import {api} from '../api/api'
import {AppContext} from '../app'
import '../css/login.css'
import AppProps from '../util/appProps'
import {errorSwitcher, isEnter, UNKNOWN_SERVER_ERROR, tagger} from '../util/util'

const Register = (props: AppProps) => {
    const {t} = useTranslation('register')
    const registerRef = useRef(null) as any

    const [name, setName] = useState('')
    const [skype, setSkype] = useState('')
    const [company, setCompany] = useState('')
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')

    const [eName, setEName] = useState([])
    const [eSkype, setESkype] = useState([])
    const [eCompany, setECompany] = useState([])
    const [eEmail, setEEmail] = useState([])
    const [ePass, setEPass] = useState([])
    const [eOther, setEOther] = useState([])

    const {utmParameters} = useContext(AppContext)

    const updateErrors = (name, skype, company, email, pass, other) => {
        setEName(name)
        setESkype(skype)
        setECompany(company)
        setEEmail(email)
        setEPass(pass)
        setEOther(other)
    }

    const handleErrors = errors => {
        const parsed = errorSwitcher(errors)
        updateErrors(parsed.name, parsed.skype, parsed.company, parsed.email, parsed.pass, parsed.other)
    }

    const register = async () => {
        updateErrors([], [], [], [], [], [])
        registerRef.current.classList.toggle('active')
        try {
            const response = await api.register({name, skype, companyName: company, email, password, utm: utmParameters || {}})
            if (response && response.userId) {
                (window as any).dataLayer.push({ 'event': 'form-completed', 'location': 'Signup' })
                props.history.push('welcome?id=' + response.userId)
            }
        } catch (e) {
            registerRef.current.classList.toggle('active')
            handleErrors(e ? e.errors : UNKNOWN_SERVER_ERROR)
        }
    }

    return (
        <div className="common-pages-container text-center login-page">
            <img src="https://static.persona.ly/images/logo_persona.svg" />
            <p>{t('register y')}</p>

            {eOther && eOther.map(err => <div className="error" key={err}>{err}</div>)}

            <div className="contact-input-container">
                <input className={'contact-input small-text' + (eName.length > 0 ? ' error-input' : '')} type="text" name="name" placeholder="&nbsp;"
                    onInput={e => setName(e.currentTarget.value)} onKeyPress={e => isEnter(e) && register()}
                />
                <span className="contact-input-label">{t('name')}</span>
            </div>
            {eName && eName.map(err => <div className="error-small" key={err}>{err}</div>)}

            <div className="contact-input-container">
                <input className={'contact-input small-text' + (eSkype.length > 0 ? ' error-input' : '')} type="text" name="skype" placeholder="&nbsp;"
                    onInput={e => setSkype(e.currentTarget.value)} onKeyPress={e => isEnter(e) && register()}
                />
                <span className="contact-input-label">{t('skype')}</span>
            </div>
            {eSkype && eSkype.map(err => <div className="error-small" key={err}>{err}</div>)}

            <div className="contact-input-container">
                <input className={'contact-input small-text' + (eCompany.length > 0 ? ' error-input' : '')} type="text" name="companyName" placeholder="&nbsp;"
                    onInput={e => setCompany(e.currentTarget.value)} onKeyPress={e => isEnter(e) && register()}
                />
                <span className="contact-input-label">{t('company n')}</span>
            </div>
            {eCompany && eCompany.map(err => <div className="error-small" key={err}>{err}</div>)}

            <div className="contact-input-container">
                <input className={'contact-input small-text' + (eEmail.length > 0 ? ' error-input' : '')} type="email" name="email" placeholder="&nbsp;"
                    onInput={e => setEmail(e.currentTarget.value)} onKeyPress={e => isEnter(e) && register()}
                />
                <span className="contact-input-label">{t('email ad')}</span>
            </div>
            {eEmail && eEmail.map(err => <div className="error-small" key={err}>{err}</div>)}

            <div className="contact-input-container">
                <input className={'contact-input small-text' + (ePass.length > 0 ? ' error-input' : '')} type="password" name="pass" placeholder="&nbsp;"
                    onInput={e => setPassword(e.currentTarget.value)} onKeyPress={e => isEnter(e) && register()}
                />
                <span className="contact-input-label">{t('password')}</span>
            </div>
            {ePass && ePass.map(err => <div className="error-small" key={err}>{err}</div>)}

            <button ref={registerRef} className="button-blue large animated" onClick={register}>{t('get started')}<img src="https://static.persona.ly/images/arrow.svg" /></button>
            <div className="to-register">{tagger(t('already sig'), 'fw500', 'login')}</div>
        </div>
    )
}

export default Register


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/pages/register.tsx